<template>
  <div class="today-visit-follow-up">
    <!-- 顶部：就诊预约概要（不含单条回访人，沟通人信息在下方列表展示） -->
    <div class="summary-section">
      <div class="summary-item row">
        <div class="flex-1">
          <span class="label font-666">就诊:</span>
          <span class="value font-333"
            >{{ $filters.formatDateTime(self.appointTime) }}
            {{ self.doctorName }}</span
          >
        </div>
        <!--状态-->
        <div class="statusRight">
          {{ self.statusText }}
        </div>
      </div>
    
    </div>

    <!-- 已回访：按条展示沟通人、时间、内容与「修改」 -->
    <div
      class="communication-section mt8"
      v-if="completedReturnVisitRows.length > 0"
    >
      <div
        v-for="(visitRow, rowIndex) in completedReturnVisitRows"
        :key="visitRow.returnVisitId || rowIndex"
        class="communication-record-item"
      >
        <div class="communication-record-head row">
          <div class="communication-meta flex-1">
            <span class="meta-label font-666">回访:</span>
            <span class="meta-text font-333">{{
              visitRow.executorName || "—"
            }}</span>
            <span class="meta-text font-333">{{
              formatRowTimeDisplay(visitRow)
            }}</span>
          </div>
          <button
            v-if="checkIfEmployeeCanEditReturnVisit(visitRow)"
            type="button"
            class="edit-outline-btn"
            @click="handleEdit(visitRow)"
          >
            修改
          </button>
        </div>
        <div class="communication-record-body font-333">
          {{ visitRow.returnVisitContent }}
        </div>
      </div>
    </div>

    <!-- 待回访：记录入口 -->
    <div class="content-section mt12" v-if="self.returnVisitStatus === 0">
      <div class="record-btn" @click="recordReturnVisit">记录回访内容</div>
    </div>
  </div>
</template>

<script>
import { todayTodoStore } from "@/store/h5/todayTodo.js";
import { userStore } from "@/store/user.js";

/** 与接口 returnVisitStatus 一致 */
const RETURN_VISIT_STATUS = {
  PENDING: 0,
  DONE: 1,
};

export default {
  name: "TodayVisitFollowUp",
  props: {
    self: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    /**
     * 需要展示的「已回访」行：多条约诊合并时有 returnVisitHistoryList；单条已回访无列表时用当前 self
     */
    completedReturnVisitRows() {
      const historyList = this.self.returnVisitHistoryList;
      if (historyList && historyList.length) {
        return historyList;
      }
      if (this.self.returnVisitStatus === RETURN_VISIT_STATUS.DONE) {
        return [this.self];
      }
      return [];
    },
  },
  methods: {
    /**
     * 沟通时间展示：优先回访时间类字段，缺省时退回预约时间
     */
    formatRowTimeDisplay(visitRow) {
      const timeValue =
        visitRow.returnVisitTime ||
        visitRow.updateTime ||
        visitRow.gmtCreate ||
        visitRow.appointTime;
      return this.$filters.formatDateTime(timeValue);
    },
    /**
     * 仅执行人为本企微员工且为已回访记录时可改
     */
    checkIfEmployeeCanEditReturnVisit(visitRow) {
      const user = userStore();
      const employeeId = user.userInfo.detail.employee_id;
      return (
        visitRow.executorId == employeeId &&
        visitRow.returnVisitStatus === RETURN_VISIT_STATUS.DONE
      );
    },
    /** 修改单条回访：带入该条的 returnVisitId / content */
    handleEdit(visitRow) {
      const todayTodoStoreInstance = todayTodoStore();
      todayTodoStoreInstance.setCurrentVisit(visitRow);
      this.$router.push(
        "/todayTodo/regCommStatus?type=todayVisitFollowUp&status=2",
      );
    },
    recordReturnVisit() {
      const todayTodoStoreInstance = todayTodoStore();
      todayTodoStoreInstance.setCurrentVisit(this.self);
      this.$router.push(
        "/todayTodo/regCommStatus?type=todayVisitFollowUp&status=1",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.today-visit-follow-up {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  padding: 0.25rem;
  margin-bottom: 0.25rem;
  text-align: left;
  box-sizing: border-box;

  .summary-section {
    .summary-item {
      display: flex;
      align-items: center;

      .label {
        font-size: 0.25rem;
        flex-shrink: 0;
        min-width: 1.25rem;
      }

      .value {
        font-size: 0.25rem;
        margin-left: 0.042rem;
        flex: 1;
      }

      .statusRight {
        font-size: .25rem;
        color: #999999;
        text-align: right;
        background-color: #fafafa;
        padding: .042rem .083rem;
        border-radius: .083rem;
      }
    }
  }

  /* 回访记录列表：首行沟通人+时间+修改，次行正文 */
  .communication-section {
    margin-top: .292rem;
    .communication-record-item {
      margin-bottom: .25rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .communication-record-head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.083rem;
    }

    .communication-meta {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 0.25rem;
      line-height: 1.5;
    }

    .meta-label {
      flex-shrink: 0;
      margin-right: 0.042rem;
    }

    .meta-text {
      margin-right: 0.083rem;
    }

    .edit-outline-btn {
      flex-shrink: 0;
      margin-left: 0.125rem;
      padding: 0.042rem 0.167rem;
      font-size: 0.25rem;
      color: #333;
      background-color: #fff;
      border: 1px solid #dcdcdc;
      border-radius: 0.083rem;
      line-height: 1.4;
      cursor: pointer;
    }

    .communication-record-body {
      font-size: 0.25rem;
      line-height: 1.6;
      word-break: break-all;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
  }

  .content-section {
    .record-btn {
      width: 5rem;
      background-color: #fff;
      color: #28b8c3;
      border: 1px solid #28b8c3;
      padding: 0.167rem 0;
      border-radius: 0.083rem;
      text-align: center;
      font-size: 0.292rem;
      cursor: pointer;
      margin: 0 auto;
      margin-top: 0.208rem;
    }
  }
}
</style>
